import { useCallback, useRef, useState } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import EditableText from "../../Texts/EditableText";
import Switch from "../../Form/Switch";

const nameActionButtonSx = {
  color: "#000",
  flexShrink: 0,
  p: 0.5,
  "&:hover": {
    backgroundColor: "#f2f2f2",
  },
};

const AutomationModalHeader = ({
  name,
  onRename,
  canEditName = true,
  showToggle = false,
  isActive = false,
  isToggleDisabled = false,
  onToggleActive,
}) => {
  const editableNameRef = useRef(null);
  const nameRowRef = useRef(null);
  const [isEditingName, setIsEditingName] = useState(false);

  const onEditingChange = useCallback((isEditing) => {
    setIsEditingName(isEditing);
  }, []);

  const onEditNameClick = () => {
    editableNameRef.current?.startEditing();
  };

  const onConfirmNameClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    editableNameRef.current?.save();
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        flex: 1,
        minWidth: 0,
        gap: 1,
        rowGap: 0.75,
        pr: 0.5,
      }}
    >
      <Box
        ref={nameRowRef}
        sx={{
          display: "flex",
          alignItems: "center",
          flex: "1 1 160px",
          minWidth: 0,
          gap: 0.8,
        }}
      >
        <EditableText
          ref={editableNameRef}
          value={name}
          variantText="h6"
          matchTextStyle
          disabledEditable={!canEditName}
          onCallbackSave={onRename}
          onEditingChange={onEditingChange}
          outsideClickRootRef={nameRowRef}
          showTooltip={false}
          sx={{ minWidth: 0, maxWidth: "100%", overflow: "hidden" }}
          sxText={{
            fontWeight: 600,
            fontSize: { xs: "1.05rem", sm: undefined },
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            display: "block",
          }}
        />
        {canEditName && isEditingName ? (
          <IconButton
            aria-label="confirm name"
            size="small"
            onMouseDown={(event) => event.preventDefault()}
            onClick={onConfirmNameClick}
            sx={nameActionButtonSx}
          >
            <CheckIcon fontSize="small" />
          </IconButton>
        ) : null}
        {canEditName && !isEditingName ? (
          <IconButton
            aria-label="edit name"
            size="small"
            onClick={onEditNameClick}
            sx={nameActionButtonSx}
          >
            <EditIcon fontSize="small" />
          </IconButton>
        ) : null}
      </Box>

      {showToggle ? (
          <Switch
            hasLabel={false}
            size="small"
            isActive={isActive}
            disabled={isToggleDisabled}
            onChangeIsActive={onToggleActive}
          />
      ) : null}
    </Box>
  );
};

export default AutomationModalHeader;
